module.exports = Em.ObjectController.extend({
    needs: ['user'],
    model: Em.computed.alias('controllers.user.activeOrganization')
})
